<template>
  <div class="tab-table">
    <simple-table
      category="rss"
      :columns="columns"
      :loading="loading"
      :error="error"
      :list="filteredList"
      :inline="true"
      inlineField="url"
      @fetch="handleFetch"
      @create="handleCreate"
      @save="handleSave"
      @remove="handleRemove"
    />
  </div>
</template>

<script>
import SimpleTable from '@/components/common/SimpleTable';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'audi-table',

  components: {
    SimpleTable,
  },

  data() {
    return {
      columns: [{ label: 'Ссылка', name: 'url', width: '60%' }],
    };
  },

  computed: {
    ...mapGetters({
      loading: 'rss/loading',
      error: 'rss/error',
      list: 'rss/list',
      categories: 'rss/categories',
    }),

    category() {
      return this.categories.find(category => category.id === 'audi');
    },

    filteredList() {
      return this.list.filter(link => link.category.id === this.category.id);
    },
  },

  methods: {
    ...mapActions({
      fetch: 'rss/fetch',
      create: 'rss/create',
      save: 'rss/save',
      remove: 'rss/remove',
    }),

    toast(msg, type) {
      if (type === 'success') {
        this.$snotify.success(msg, null, {
          showProgressBar: false,
        });
      }
      if (type === 'error') {
        this.$snotify.error(msg, null, {
          showProgressBar: false,
        });
      }
    },

    handleFetch(params) {
      if (this.category) {
        this.fetch({ ...params, category: this.category }); // TODO: fetch вызывается дважды, исправить
      }
    },

    async handleCreate(value) {
      const err = await this.create({
        url: value,
        category: this.category,
      });

      if (!err) {
        this.toast('Ссылка на новостную ленту создана.', 'success');
      } else {
        this.toast('Произошла ошибка.', 'error');
      }
    },

    async handleSave(id, value) {
      const err = await this.save({
        id,
        url: value,
        category: this.category,
      });

      if (!err) {
        this.toast('Изменения сохранены.', 'success');
      } else {
        this.toast('Произошла ошибка.', 'error');
      }
    },

    async handleRemove(id) {
      const err = await this.remove({
        id,
        category: this.category,
      });

      if (!err) {
        this.toast('Запись успешно удалена.', 'success');
      } else {
        this.toast('Произошла ошибка.', 'error');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-table {
  display: flex;
  flex-direction: column;
  flex: 1;
}
</style>
